import React, { useState } from "react";
import withMeta from '../../utils/withMeta';
import Stepper from "../../Stepper";
import ConfirmDialog from "../../dialogs/ConfirmDialog";

import "./UzWizard.scss";

import UzDetail from "./UzDetail";
import Method from "./Method";
import UzApl from "./UzApl";
import UzPrj from "./UzPrj";
import PravaPrj from "./PravaPrj";
import Skup from "./Skup";
import PravaSkup from "./PravaSkup";
import Button from "../../buttons/Button";
import withRouter from "../../utils/withRouter";
import { useDidMount } from '../../utils/hooks';

const initialItems = [
  {
    id: 0,
    label: "Zaevidovanie používateľa",
  },
  {
    id: 1,
    label: "Priradenie aplikácií",
  },
  {
    id: 2,
    label: "Spôsob priradenia práv",
  },
  {
    id: 3,
    label: "Priradenie projektov",
  },
  {
    id: 4,
    label: "Nastavenie práv",
  }
];

const UzWizard = (props) => {
  const [items, setItems] = useState(initialItems);
  const [step, setStep] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [uz, setUz] = useState(null);
  const [method, setMethod] = useState(null);
  const [apl, setApl] = useState(null);
  const [prj, setPrj] = useState(null);
  const [skup, setSkup] = useState(null);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);

  const init = () => {
    removeValidation();
    setStep(0);
    setRefresh(0);
    setApl(null);
    setPrj(null);
    setSkup(null);
  };

  useDidMount(() => {
    if (props.location?.state?.uz) {
      setUz(props.location.state.uz);
    }
    init();
  })

  const nextStep = () => {
    handleChange(step + 1);
  };

  const handleChange = (newStep) => {
    if (!items[step].isValid && step < newStep) {
      setRefresh(refresh + 1);
      return;
    }
    if (newStep < step) {
      removeValidation(newStep);
    }
    setRefresh(refresh + 1);
    setStep(newStep);
  };

  const removeValidation = (currentStep = 0) => {
    const newItems = items.map(({ isValid, ...x }, index) => {
      if (index < currentStep) {
        return { ...x, isValid };
      }
      return x;
    });
    setItems(newItems);
  };

  const changeValidationItems = (currentStep, isValid) => {
    const newItems = [...items];
    newItems[currentStep].isValid = isValid;
    setItems(newItems);
  };


  const handleSetUz = (uz) => {
    setUz(uz);
    changeValidationItems(step, true);
    nextStep();
  };

  const handleSetItems = (value) => {
    changeValidationItems(step, true);
    const newItems = value.value.map(({ isValid: _, ...x }) => x);
    setItems([...items.slice(0, 3), ...newItems]);
    setMethod(value);
    nextStep();
  };

  const handleSetApl = (apl) => {
    setApl(apl);
    changeValidationItems(step, true);
    nextStep();
  };

  const handleSetPrj = (prj) => {
    setPrj(prj);
    changeValidationItems(step, true);
    nextStep();
  };

  const handleSetSkup = (skup) => {
    setSkup(skup);
    changeValidationItems(step, true);
    nextStep();
  };

  const exit = () => {
    init();
    setUz(null);
    if (props.location?.state?.from) {
      props.navigate(props.location.state.from);
    } else {
      props.navigate({ pathname: '/form/IUz' });
    }
  };

  const onExit = () => {
    if (step > 0) {
      setIsOpenConfirm(true);
    } else {
      exit();
    }
  };

  const handleCloseDialog = async () => {
    setIsOpenConfirm(false);
  };

  const handleConfirmDialog = async () => {
    await handleCloseDialog();
    exit();
  };

  const getStep = () => {
    switch (items[step].id) {
      case 0:
        return <UzDetail
          refresh={refresh}
          setUz={handleSetUz}
          uz={uz}
          db={props.location?.state?.db}
        />;
      case 1:
        return <UzApl
          refresh={refresh}
          uz={uz}
          apl={apl}
          setApl={handleSetApl}
          db={props.location?.state?.db}
        />;
      case 2:
        return <Method
          refresh={refresh}
          setItems={handleSetItems}
          method={method}
        />;
      case 3:
        return <UzPrj
          refresh={refresh}
          uz={uz}
          apl={apl}
          prj={prj}
          setPrj={handleSetPrj}
          db={props.location?.state?.db}
        />;
      case 4:
        return <PravaPrj
          refresh={refresh}
          uz={uz}
          onSubmit={exit}
          db={props.location?.state?.db}
        />;
      case 5:
        return <Skup
          refresh={refresh}
          uz={uz}
          apl={apl}
          skup={skup}
          setSkup={handleSetSkup}
          db={props.location?.state?.db}
        />;
      case 6:
        return <PravaSkup
          refresh={refresh}
          uz={uz}
          onSubmit={exit}
          db={props.location?.state?.db}
        />;
      default:
        return <div></div>;
    }
  };

  return (
    <>
      <div className="uz-wizard">
        <Stepper
          items={items}
          value={step}
          handleChange={handleChange}
          linear={true}
        />
        {getStep()}
        <Button
          buttonWrapperClassName={"wizard-exit"}
          label={"Ukončiť"}
          onClick={onExit}
        />
      </div>

      <ConfirmDialog
        isOpen={isOpenConfirm}
        onClose={handleCloseDialog}
        onConfirm={handleConfirmDialog}
        text={"Chcete ukončiť úpravu používateľa?"}
        confirmText="Áno"
        cancelText="Nie"
      />
    </>
  );
}

export default withRouter(withMeta(UzWizard));